import './ChooserWithIcons.css';
import React from 'react';
var ChooserWithIcons = function ChooserWithIcons(_ref) {
  var className = _ref.className,
    items = _ref.items,
    selectedItemId = _ref.selectedItemId,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(className)
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.id,
      id: item.id,
      name: item.name,
      svgIcon: item.svgIcon,
      isSelected: selectedItemId === item.id,
      onChange: function onChange() {
        return _onChange && _onChange(item.id);
      }
    });
  }));
};
export default ChooserWithIcons;
var commonStyles = "c1faoj14";
var Item = function Item(_ref2) {
  var id = _ref2.id,
    name = _ref2.name,
    svgIcon = _ref2.svgIcon,
    isSelected = _ref2.isSelected,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "chooser-item ".concat(commonItemStyles, " ").concat(isSelected ? "".concat(commonItemStyles, "__selected") : "")
  }, /*#__PURE__*/React.createElement("input", {
    className: "chooser-item__hidden-radio",
    id: id,
    type: "radio",
    checked: isSelected,
    onChange: onChange,
    onClick: onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "chooser-item__icon-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chooser-item__icon",
    "aria-hidden": true,
    dangerouslySetInnerHTML: {
      __html: svgIcon
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "chooser-item__text"
  }, name));
};
var commonItemStyles = "cv7g3de";